import {useState, useCallback, useEffect} from 'react';
import useDeepCompareMemoize from 'hooks/deepCompareMemoize';
import api from 'services/api';

// import { getStoredAuthToken, removeStoredAuthToken } from 'shared/utils/authToken';

const useMutation = (method, url) => {
  const [state, setState] = useState({
    data: null,
    error: null,
    isWorking: false,
  });

  const makeRequest = useCallback(
    (variables = {}) =>
      new Promise((resolve, reject) => {
        setState(currentState => ({ ...currentState, isWorking: true }));

        api.apiRequest(method, url, variables).then(
          data => {
            resolve(data);
            setState(currentState => ({...currentState, data, error: null, isWorking: false}))
          },
          error => {
            reject(error);
            setState(currentState => ({...currentState,  error, data: null, isWorking: false}))
          },
        );
      }),
    [method, url, setState],
  );

  return [
    {
      ...state,
    },
    makeRequest,
  ];
};


const useQuery = (url, propsVariables = {} ) => {

  const [state, setState] = useState({
    data: null,
    error: null,
    isLoading: false,
  });

  const propsVarsMemoized = useDeepCompareMemoize(propsVariables);

  const makeRequest = useCallback(
    newVariables => {
      const apiVariables = { ...propsVarsMemoized, ...(newVariables || {}) };

      setState(currentState => ({ ...currentState, isLoading: true}) );

      api.get(url, apiVariables).then(
        data => {
          setState(currentState => ({...currentState, data, error: null, isLoading: false}))
        },
        error => {
          setState(currentState => ({...currentState, error, data: null, isLoading: false}))
        },
      );
    },
    [url, propsVarsMemoized],
  );


  useEffect(() => { 
    makeRequest() }, 
    [makeRequest]
  );

  return [ { ...state, }, makeRequest, ];
};


/* eslint-disable react-hooks/rules-of-hooks */
export default {
  get: (...args) => useQuery(...args),
  post: (...args) => useMutation('post', ...args),
  put: (...args) => useMutation('put', ...args),
  patch: (...args) => useMutation('patch', ...args),
  delete: (...args) => useMutation('delete', ...args),
};
